<template>
  <span class="checkbox mr-1" @click="toggle">
    <Checked v-if="isChecked"></Checked>
    <Unchecked v-else></Unchecked>
  </span>
</template>
<script>
import Checked from '@/components/Icons/Checked'
import Unchecked from '@/components/Icons/Unchecked'
export default {
  components: {
    Checked,
    Unchecked
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isChecked: false
    }
  },
  watch: {
    value (v) {
      this.isChecked = v
    }
  },
  methods: {
    toggle () {
      this.isChecked = !this.isChecked
      this.$emit('change', this.isChecked)
    }
  }
}
</script>
<style lang="scss">
.checkbox {
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
    margin-bottom: 2px;
  }
}
</style>
